import React from "react";

/**
 * Lightweight client-side preview of the QR customization.
 * The real, scannable QR image (with embedded logo) is generated
 * server-side by Django + Pillow once the form is submitted; this
 * component just gives the user an instant visual approximation.
 */
export default function QRPreview({ qrColor, backgroundColor, qrDesign, logoEnabled, logoPreviewUrl, logoSize, logoShape }) {
  const moduleRadius = qrDesign === "dots" ? "50%" : qrDesign === "rounded" ? "4px" : "0px";

  // Simple decorative grid to represent the QR pattern with chosen colors/design
  const cells = Array.from({ length: 49 });

  return (
    <div className="qr-preview-box">
      <div style={{ position: "relative", width: 220, height: 220, background: backgroundColor, borderRadius: 8, padding: 12 }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4, width: "100%", height: "100%" }}>
          {cells.map((_, i) => (
            <div
              key={i}
              style={{
                background: (i * 7 + i) % 3 === 0 ? qrColor : "transparent",
                borderRadius: moduleRadius,
              }}
            />
          ))}
        </div>
        {logoEnabled && (
          <img
            src={logoPreviewUrl || "https://via.placeholder.com/60?text=Logo"}
            alt="logo preview"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: `${logoSize || 20}%`,
              maxWidth: 70,
              borderRadius: logoShape === "circle" ? "50%" : logoShape === "rounded" ? "10px" : "2px",
              background: "#fff",
              padding: 3,
              border: "2px solid #fff",
            }}
          />
        )}
      </div>
    </div>
  );
}
